import { Dialog } from '@capacitor/dialog';

export default async function alert(message, alertCallback=function(){}, title='Intimately Us', buttonName='OK') {
  
  await Dialog.alert({
    title: title,
    message: message,
    buttonTitle: buttonName,
  });
  alertCallback();
}
